import React from 'react';
import { X } from 'lucide-react';

interface JoinWaitlistModalProps {
  isOpen: boolean;
  onClose: () => void;
  onJoin: () => void;
  title?: string;
  message?: string;
}

const JoinWaitlistModal: React.FC<JoinWaitlistModalProps> = ({
  isOpen,
  onClose,
  onJoin,
  title = "Join waitlist",
  message = "This is a test version with limited functionality for demonstration purposes!\n\nFuture versions will support more features.\n\nPlease click \"Join Waitlist\" to stay updated on our development progress!"
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl p-6 mx-4 max-w-sm w-full shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold" style={{ color: 'var(--charcoal)' }}>
            Join SurePal waitlist 🚀
          </h2>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
          >
            <X className="w-5 h-5" style={{ color: 'var(--medium-gray)' }} />
          </button>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-sm leading-relaxed whitespace-pre-line" style={{ color: 'var(--medium-gray)' }}>
            {message}
          </p>
        </div>

        {/* Buttons */}
        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 rounded-lg border text-sm font-medium transition-all duration-200"
            style={{
              background: 'var(--pure-white)',
              color: 'var(--medium-gray)',
              border: '1px solid var(--card-shadow)',
              borderRadius: '8px',
              boxShadow: '0 2px 6px var(--input-shadow)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--card-gradient)';
              e.currentTarget.style.borderColor = 'var(--brand-teal)';
              e.currentTarget.style.color = 'var(--charcoal)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'var(--pure-white)';
              e.currentTarget.style.borderColor = 'var(--card-shadow)';
              e.currentTarget.style.color = 'var(--medium-gray)';
            }}
          >
            Cancel
          </button>
          <button
            onClick={onJoin}
            className="flex-1 h-12 flex items-center justify-center px-0 text-sm font-medium text-white relative overflow-hidden transition-all duration-200"
            style={{
              background: 'var(--charcoal)',
              border: 'none',
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0, 20, 20, 0.15)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 229, 230, 0.15)';
              e.currentTarget.style.position = 'relative';
              e.currentTarget.style.overflow = 'hidden';
              
              // 創建亮藍色旋光效果（淡出，不持續動畫）
              const glowElement = document.createElement('div');
              glowElement.style.cssText = `
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: linear-gradient(135deg, rgba(0, 229, 230, 0.8) 0%, rgba(0, 20, 20, 0.6) 50%, rgba(0, 229, 230, 0.3) 100%);
                pointer-events: none;
                z-index: 1;
                opacity: 0;
                transition: opacity 0.3s ease-in-out;
              `;
              glowElement.className = 'join-glow-effect';
              e.currentTarget.appendChild(glowElement);
              
              // 淡入效果
              setTimeout(() => {
                glowElement.style.opacity = '1';
              }, 10);
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 20, 20, 0.15)';
              
              // 淡出效果
              const glowElement = e.currentTarget.querySelector('.join-glow-effect') as HTMLElement;
              if (glowElement) {
                glowElement.style.opacity = '0';
                setTimeout(() => {
                  if (glowElement.parentNode) {
                    glowElement.parentNode.removeChild(glowElement);
                  }
                }, 300);
              }
            }}
          >
            <div className="flex items-center justify-center gap-3" style={{ position: 'relative', zIndex: 2 }}>
              <span className="font-medium">Join</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default JoinWaitlistModal;
